














































































import { Component, Vue, Prop } from "vue-property-decorator";
import BaseRepository from "@/core/HttpResources/BaseRepository";
import LanguageLabel from "@/models/language/LanguageLabel/languageLabel.model";
import BTableColumn from "@/models/base/BTableColumn.model";
import GenericBTable from "@/core/Generics/GenericBTable";
import { BTableColumnType } from "@/enums/BTableColumnType";
import LanguageService from "@/services/language.service";
import { PermissionValue } from '@/enums/PermissionValue';
import LanguageLabelService from "@/services/LanguageLabel.service";


@Component
export default class LanguageLabelTable extends GenericBTable<LanguageLabel> {
  isLoading = false;
  name = "";
  languageService = new LanguageService();
  langaugeLabelService = new LanguageLabelService();
  created() {
    this.permissionValue = PermissionValue.IDIOMAS;
    this.tableConfig.controller = "LanguageLabel";
    this.tableConfig.whereParams = `languageGroupId eq 
     ${this.$route.params.languageGroupId} and
      languageId eq ${this.$route.params.languageId} `;
  }
  
  mounted() {
    this.formatColumns();
  }

  formatColumns() {
    let nombre = new BTableColumn("value", "table.name");
    let codigo = new BTableColumn("key", "table.code");
    this.tableConfig.insertColumns(nombre, codigo);
    this.tableConfig.activeActions = this.permissionAccess.write;
    this.tableConfig.actions.customTemplate = this.permissionAccess.write;
  }
  searcherLabel(event: any){
     if (event.keyCode === 13) {
         this.tableConfig.whereParams = `languageGroupId eq  
         ${this.$route.params.languageGroupId} and languageId eq ${this.$route.params.languageId}
          and contains(Value, '${this.name}')`;
         this.tableConfig.reload();
     }
  }


  generateJSON() {
    this.isLoading = true;
    this.languageService
      .generateJSON()
      .then(msg => {
        localStorage.setItem("locales", JSON.stringify(msg));
        this.$i18n.setLocaleMessage(this.$i18n.locale, msg[this.$i18n.locale]);
        this.operationSuccess();
      })
      .finally(() => {
        this.isLoading = false;
      });
  }
}
